import { render, staticRenderFns } from "./MenuCardNotifications.vue?vue&type=template&id=a24dc3be&scoped=true"
import script from "./MenuCardNotifications.vue?vue&type=script&lang=js"
export * from "./MenuCardNotifications.vue?vue&type=script&lang=js"
import style0 from "./MenuCardNotifications.vue?vue&type=style&index=0&id=a24dc3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24dc3be",
  null
  
)

export default component.exports